import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { apiRemote } from '@/api';

interface SiteAlertContextType {
  message: string;
  open: boolean;
  isActive: boolean;
  setMessage: (msg: string) => void;
  close: () => void;
  show: () => void;
  reload: () => Promise<void>;
}

const SiteAlertContext = createContext<SiteAlertContextType | undefined>(undefined);

export const SiteAlertProvider = ({ children }: { children: React.ReactNode }) => {
  const [message, setMessageState] = useState('');
  const [open, setOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const setMessage = (msg: string) => {
    setMessageState(msg);
    setOpen(true);
  };

  const close = () => setOpen(false);
  const show = () => setOpen(true);

  const fetchSiteAlert = useCallback(async () => {
    try {
      apiRemote.getSiteAlert().then((data)=>{
          setMessage(data.data.message || "");
          setIsActive(data.data.is_active);
      });
    } catch (error) {
      console.error("Failed to fetch banner message", error);
    }
  }, []);

  // Gọi khi component mount
  useEffect(() => {
    fetchSiteAlert();
  }, [fetchSiteAlert]);

  return (
    <SiteAlertContext.Provider value={{ message, open, setMessage, close, show, reload: fetchSiteAlert, isActive: isActive }}>
      {children}
    </SiteAlertContext.Provider>
  );
};

export const useSiteAlert = () => {
  const context = useContext(SiteAlertContext);
  if (!context) throw new Error("useBanner must be used within a BannerProvider");
  return context;
};